export const STATUS_OPTIONS = [
    { value: "open", label: "Open", color: "bg-green-500" },
    { value: "in_progress", label: "In Progress", color: "bg-yellow-500" },
    { value: "resolved", label: "Resolved", color: "bg-blue-500" },
    { value: "closed", label: "Closed", color: "bg-gray-500" },
]

export const PRIORITY_OPTIONS = [
    { value: "critical", label: "Critical", color: "bg-red-600" },
    { value: "high", label: "High", color: "bg-orange-600" },
    { value: "medium", label: "Medium", color: "bg-yellow-600" },
    { value: "low", label: "Low", color: "bg-green-600" },
]
export const BUG_OPTIONS = [
    { value: "bug", label: "Bug", icon: "🐞" },
    { value: "feature_request", label: "Feature Request", icon: "✨" },
    { value: "improvement", label: "Improvement", icon: "⚙️" },
]